import { Form, Formik } from 'formik';
import FormActionButtonLayout from '../../../components/layout/Form/FormActionButtonLayout';
import { Button } from '@mui/material';
import DialogAction from '../../../components/Dialog/DialogAction';
import { isSubmitEnabled } from '../../../lib/helperFuncs';
import { useState } from 'react';
import { initialValuesCollection, initialValuesDocument, initialValuesForeas, initialValuesProject } from './types';
import FormStepperBuilder from '../../../components/form_v2/highLevelComponents/FormStepperBuilder';
import { FormInStepperBuilder } from '../../../components/form_v2/helpers';

    
export interface IPropsRegistrationStep{
    initialValues: initialValuesForeas | initialValuesCollection 
    | initialValuesDocument | initialValuesProject;
    onSubmit: (values: any) => void;
    validation: any;
    step: FormInStepperBuilder[] | any[];
}

const RegistrationStepComponent = (props: IPropsRegistrationStep) => {
  const {initialValues, validation, step, onSubmit} = props;

  const [openSubmit, setOpenSubmit] = useState<boolean>(false);
  const [openCancel, setOpenCancel] = useState<boolean>(false);

  return (
    <>
      <Formik
        enableReinitialize
        onSubmit={()=> undefined}
        initialValues={initialValues}
        validationSchema={validation}
        validateOnBlur={false}
      >
        {formik =>
          (<>
            <Form>
              <FormStepperBuilder formik={formik} form={step}/>
              <FormActionButtonLayout>
                <Button 
                  variant='outlined' color='error'
                  onClick={() => setOpenCancel(true)}> 
                  {'Ακύρωση Καταχώρισης'}               
                </Button>
                <Button 
                  variant='contained' 
                  disabled={isSubmitEnabled(formik?.errors, formik?.dirty)}
                  onClick={() => setOpenSubmit(true)}> 
                  {'Υποβολή εκκίνησης Καταχώρισης'}               
                </Button>
                <DialogAction open={openCancel} handleClose={() => setOpenCancel(false)}
                  title={'Ακύρωση Εκκίνησης'} 
                  content={'Είστε σίγουρος/η ότι θέλετε να ακυρώσετε την Εκκίνηση Καταχώρισης;'}
                  onAccept={() => {
                    setOpenCancel(false); 
                  }}/>
                <DialogAction open={openSubmit} handleClose={() => setOpenSubmit(false)}
                  title={'Υποβολή εκκίνησης Καταχώρισης'} 
                  content={'Είστε σίγουρος/η ότι θέλετε να γίνει η Υποβολή Εκκίνησης Καταχώρισης;'}
                  onAccept={() => {
                    onSubmit(formik?.values);
                    setOpenSubmit(false); 
                  }}/>
              </FormActionButtonLayout>
            </Form>
          </>)
        }
      </Formik>
    </>
  );
};

export default RegistrationStepComponent;